import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';

import { LocaleService } from './locale.service';

export const Ng1LocaleModule = angular
  .module('control-room.angular.locale-service', [])
  .factory('crLocaleService', downgradeInjectable(LocaleService));
